import { Skeleton, Space } from "antd";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { useAuth } from "src/core/hooks/useAuth";
import { PackagingManager } from "src/modules/PriceConfiguratorManager/components/DataSectionManager/sections/Packaging/components/PackagingManager/PackagingManager";
import { currentPriceConfiguratorState } from "src/recoil/atoms";
import { DataSectionData } from "src/types/priceConfigurator";

type Props = {
  dataSection: DataSectionData;
};

export const Packaging: React.FC<Props> = (props: Props) => {
  const { dataSection } = props;

  const { success, authLoaded } = useAuth();

  const currentPriceConfigurator = useRecoilValue(
    currentPriceConfiguratorState
  );

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (authLoaded && success) {
        setLoading(false);
      }
    })();
  }, [authLoaded, success]);

  return (
    <Space
      direction="vertical"
      size={0}
      style={{ marginBottom: 50 }}
      className="full-width-space"
    >
      <Skeleton
        loading={loading}
        active
        style={{ minHeight: 200, minWidth: 200 }}
      >
        <PackagingManager
          priceConfiguratorId={currentPriceConfigurator.id}
          modelNumber={currentPriceConfigurator.modelNumber}
          dataSectionId={dataSection.id}
        />
      </Skeleton>
    </Space>
  );
};
